module.exports = __webpack_public_path__ + "img/1220777628.f5aa8ded.jpg";